export default class StudentRepository {
  baseUrl;

  constructor(baseUrl) {
    if (baseUrl) {
      this.baseUrl = baseUrl;
    } else {
      this.baseUrl = window.location.origin;
    }
  }

  generateUrl(relativePath) {
    const relativePathCleaned = relativePath.replace(/\/{2,}/g, '/');
    const url = `${this.baseUrl}${relativePathCleaned}`;
    return url;
  }

  async getStudentRecords(studid, mother_maiden, birthdate) {
    const url = this.generateUrl(`/me/student-records`);
    return fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ studid, mother_maiden, birthdate }), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return response.json();
    });
  }

  async getAlumniRecord() {
    return fetch(this.generateUrl(`/me/alumni-records`), {
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return response.json();
    });
  }

  async addManualEntry(manualEntryObject) {
    return fetch(this.generateUrl('/me/alumni-records'), {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(manualEntryObject), // body data type must match "Content-Type" header
    }).then((response) => response.json());
  }

  async changeCivilStatus(civil_status, married_name) {
    let values = { civil_status };
    if (married_name) values = { ...values, ...{ married_name } };
    return fetch(this.generateUrl('/me/alumni-records/civil-status'), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async changeFirstGenStatus(is_first_gen_graduate) {
    const values = { is_first_gen_graduate };
    return fetch(this.generateUrl('/me/alumni-records/first-gen-status'), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async updateAddresses(addresses) {
    return fetch(this.generateUrl('/me/alumni-records/addresses'), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(addresses), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async updateContacts(contact_number, social_media, email) {
    return fetch(this.generateUrl('/me/alumni-records/contacts'), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ contact_number, social_media, email }), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }
  async getExams() {
    return fetch(this.generateUrl('/me/alumni-records/exams'), {
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return response.json();
    });
  }

  async addExamination(examObject) {
    return fetch(this.generateUrl('/me/alumni-records/exams'), {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(examObject), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async updateExamination(examId, examObject) {
    return fetch(this.generateUrl(`/me/alumni-records/exams/${examId}`), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(examObject), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async deleteExamination(examId) {
    return fetch(this.generateUrl(`/me/alumni-records/exams/${examId}`), {
      method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }
  async getEmploymentRecords() {
    return fetch(this.generateUrl('/me/alumni-records/jobs'), {
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return response.json();
    });
  }

  async getPostGradActivity() {
    return fetch(this.generateUrl('/me/alumni-records/jobs?after_graduation=1'), {
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return response.json();
    });
  }

  async addEmploymentRecord(employmentObject) {
    return fetch(this.generateUrl('/me/alumni-records/jobs'), {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(employmentObject), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }
  async updateEmploymentRecord(recordId, employmentObject) {
    return fetch(this.generateUrl(`/me/alumni-records/jobs/${recordId}`), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(employmentObject), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async updateMonthsBeforeFirstJob(
    months_before_first_job,
    is_employed_two_yrs_postgrad,
    is_studying_two_yrs_postgrad
  ) {
    return fetch(this.generateUrl(`/me/alumni-records/job-facts`), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        months_before_first_job,
        is_employed_two_yrs_postgrad,
        is_studying_two_yrs_postgrad,
      }), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async deleteEmploymentRecord(recordId) {
    return fetch(this.generateUrl(`/me/alumni-records/jobs/${recordId}`), {
      method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }
  async addCareerBreakRecord(careerBreakObject) {
    return fetch(this.generateUrl('/me/alumni-records/career-breaks'), {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(careerBreakObject), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async updateCareerBreakRecord(recordId, careerBreakObject) {
    return fetch(this.generateUrl(`/me/alumni-records/career-breaks/${recordId}`), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(careerBreakObject), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async deleteCareerBreak(recordId) {
    return fetch(this.generateUrl(`/me/alumni-records/career-breaks/${recordId}`), {
      method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async updateProgramSynthesis(competencies, suggestions) {
    const competencyString = competencies.join(', ');
    return fetch(this.generateUrl('/me/alumni-records/program-synthesis'), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ competencies: competencyString, suggestions }), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async updateEmploymentStatus(employment_status, job_course_alignment) {
    const values = { employment_status };
    if (job_course_alignment) {
      values.job_course_alignment = job_course_alignment;
    }

    return fetch(this.generateUrl('/me/alumni-records/employment-status'), {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values), // body data type must match "Content-Type" header
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }

  async logout() {
    return fetch(this.generateUrl('/me/logout'), {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      return true;
    });
  }
}
